<tile
  (onClick)="onClick.emit()"
  [active]="active"
  [title]="'GOES LIVE ON: ' + startDate"
  [hoverActive]="hoverActive"
>
  <ng-content></ng-content>
</tile>
